<!-- newsletter-wrap -->
@if (form) {
  <form [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="d-md-inline-flex d-flex align-items-md-center flex-md-row flex-column w-100">
      @if (!hideNameInNewsletter) {
        <div class="ms-md-0 me-md-2"
          [ngClass]="{'has-danger': form.get('name').touched && form.get('name').errors}">
          <label for="fullName" class="sr-only" translate>Full Name</label>
          <input type="text" class="form-control rounded-pill mb-1 mb-lg-0" id="fullName" name="fullName" formControlName="name"
            placeholder="{{'Full Name'|translate}}">
        </div>
      }
      <div class="w-100"
        [ngClass]="{'has-danger': form.get('mail').touched &&form.get('mail').errors}">
        <label for="email" class="sr-only" translate>Email Address</label>
        <input type="email" class="form-control rounded-pill mb-1 mb-lg-0" id="email" name="mail"
          formControlName="mail"
          placeholder="{{'Email Address'|translate}}">
      </div>
      <div class="me-md-0 ms-md-2">
        <button type="submit"
          class="btn app-btn-newsletter app-third-fill-btn px-4"
          spinEl
          [spinning]="submitSpinner"
          [disabled]="!form.valid"
          translate>Send
        </button>
      </div>
    </div>
  </form>
}
<!-- end-newsletter-wrap -->
